import { useUser } from "../index";

export const useUserPermissions = () => useUser().user?.userPermissions;
